import React, { useState } from "react";
import "../../styles/submenu.css";
import { withNamespaces } from 'react-i18next';

const Submenu = ({t}) => {

    const [isOpenGeral, setIsOpenGeral] = useState(false);
    return (
        <nav className="navbar navbar-expand-lg submenu-geral position-sticky">
            <div className="container">
                <h3 className="page-title">{t('modulePrepararViagem:T')}</h3>
                <button id="prepararviagem" onClick={() => setIsOpenGeral(!isOpenGeral)} className="submenu-btn" type="button" data-bs-toggle="collapse" data-bs-target="#preparar-submenu" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                    <i className={`fas fa-chevron-${isOpenGeral ? 'up' : 'down'}`}></i>
                </button>
                <div className={`collapse navbar-collapse ${isOpenGeral ? 'show' : ''}`} id="preparar-submenu">
                    <ul className="navbar-nav page-subtitles">
                        <li>
                            <a href="#1" className="submenu-link" onClick={()=>setIsOpenGeral(false)}>{t('modulePrepararViagem:S1.T')}</a>
                        </li>
                        <li>
                            <a href="#2" className="submenu-link" onClick={()=>setIsOpenGeral(false)}>{t('modulePrepararViagem:S2.T')}</a>
                        </li>
                        <li>
                            <a href="#3" className="submenu-link" onClick={()=>setIsOpenGeral(false)}>{t('modulePrepararViagem:S3.T')}</a>
                        </li>
                        <li>
                            <a href="#4" className="submenu-link" onClick={()=>setIsOpenGeral(false)}>{t('modulePrepararViagem:S4.T')}</a>
                        </li>
                        <li>
                            <a href="#5" className="submenu-link" onClick={()=>setIsOpenGeral(false)}>{t('modulePrepararViagem:S5.T')}</a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav >
    );
};

export default withNamespaces() (Submenu);

